import * as PIXI from 'pixi.js';
import gsap from "gsap";
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import Tools from '../utils/Tools';

export default class Coin extends PIXI.Container {
    constructor() {
        super();

        // Background of the coin
        this.coinBackground = null;

        // The coin icon
        this.coinIcon = null;

        // The coin number
        this.coinNumberText = null;

        // The number of coins
        this.coinNumber = 0;

        this.initCoin();
    }

    initCoin() {
        //console.log("initCoin");
        // Read the H5SDK 

        // Initialize the coin background
        const coinBackgroundTexture = AssetsManager.texturesPixi.coinBackground;
        this.coinBackground = new PIXI.Sprite(coinBackgroundTexture);
        this.coinBackground.scale.set(0.45);
        this.coinBackground.anchor.set(1, 0);
        // this.coinBackground.x = window.innerWidth;
        this.coinBackground.y = 0;
        this.addChild(this.coinBackground);

        // Initialize the coin icon
        const coinGoldTexture = AssetsManager.texturesPixi.coinsGold;
        this.coinIcon = new PIXI.Sprite(coinGoldTexture);
        this.coinIcon.scale.set(0.13);
        this.coinIcon.anchor.set(.5, .5);
        // this.coinIcon.x = window.innerWidth - 70;
        this.coinIcon.y = 56;
        this.addChild(this.coinIcon);

        // Initialize the coin number
        const coinNumberStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 23,
            fill: '#ffffff',
        });
        this.coinNumberText = new PIXI.Text(this.coinNumber, coinNumberStyle);
        // this.coinNumberText.x = window.innerWidth - 5;
        this.coinNumberText.y = 56;
        this.coinNumberText.anchor.set(1, .5);
        this.addChild(this.coinNumberText);


    }

    resize(w, h, coef) {

        this.coinBackground.x = w;
        this.coinIcon.x = w - 95;
        this.coinNumberText.x = w - 5;

        if (coef < 1) {
            this.y = 55 * coef;
        } else {
            this.y = 70;
            this.scale.set(1);
        }

    }



    updateCoin(coin) {

        let delta = coin - this.coinNumber;
        this.coinNumber = coin;
        // if (this.coinNumber > 9999) {
        //     this.coinNumberText.text = "9999";
        // }
        // else {
        // this.coinNumberText.text = this.coinNumber;
        gsap.to(this.coinNumberText, {
            duration: delta > 10 ? .5 : .1, text: this.coinNumber, onUpdate: () => {
                this.coinNumberText.text = parseInt(this.coinNumberText.text);                
                if (this.coinNumber >= 10000) {
                    this.coinNumberText.width = 70;
                    this.coinNumberText.scale.y = this.coinNumberText.scale.x;
                }
            }
        });

        this.coinIcon.scale.set(.2);
        this.scaleTween && this.scaleTween.kill();
        this.scaleTween = gsap.to(this.coinIcon.scale, { delay: .1, duration: .3, x: .13, y: .13 });
        // }
    }

    notEnoughCoin() {
        // Change the color of the background
        this.coinBackground.tint = 0xff0000;
        gsap.delayedCall(0.3, () => {
            this.coinBackground.tint = 0xffffff;
        });

        const coinBackgroundY = this.coinBackground.y;
        // Shake the background
        gsap.fromTo(this.coinBackground,
            { y: this.coinBackground.y - 5 },
            {
                y: this.coinBackground.y, duration: 0.1, repeat: 3, ease: "elastic.out(1, 0.3)", onComplete: () => {
                    this.coinBackground.y = coinBackgroundY;
                },
            },

        );
    }


    get coinPos() {
        return { x: this.coinIcon.x - 20, y: this.coinIcon.y + this.y };
    }

}